import type { InstallableChoices } from '@cli-types/core-engine/commands.js'
import { resolveConfigOrExit } from '@next-adapter/config/resolve-config-or-exit.js'
import { listAvailableIntegrations } from '@next-adapter/integration-runtime/list-available-integrations.js'
import { listAvailablePresets } from '@next-adapter/preset-runtime/list-available-presets.js'

export async function listInstallableChoices(cwd: string): Promise<InstallableChoices> {
  const config = await resolveConfigOrExit(cwd)
  const installedPresets = new Set(config.presets.installed)
  const installedIntegrations = new Set(config.integrations.installed)

  return {
    presets: listAvailablePresets().map((preset) => ({
      id: preset.id,
      description: preset.description,
      installed: installedPresets.has(preset.id)
    })),
    integrations: listAvailableIntegrations().map((integration) => ({
      id: integration.id,
      description: integration.description,
      installed: installedIntegrations.has(integration.id)
    }))
  }
}
